import { z } from 'zod';
import { isoUtcDateTimeSchema } from '../shared/schemas.js';
import { actionDescriptionSchema } from './action.schemas.js';

/**
 * Action personnalisée d'une opération (TD-026) : créée par l'organisateur de
 * l'opération ou un admin, utilisable dans cette seule opération.
 */
export const customActionSchema = z.object({
  id: z.number().int().positive(),
  description: z.string(),
  isActive: z.boolean(),
  createdAt: isoUtcDateTimeSchema,
  updatedAt: isoUtcDateTimeSchema,
});

export type CustomAction = z.infer<typeof customActionSchema>;

export const saveCustomActionSchema = z
  .object({
    description: actionDescriptionSchema,
  })
  .strict();

export type SaveCustomActionInput = z.infer<typeof saveCustomActionSchema>;

export const customActionListSchema = z.object({
  customActions: z.array(customActionSchema),
});

export type CustomActionList = z.infer<typeof customActionListSchema>;
